module.exports = __webpack_public_path__ + "static/img/xq-default-bg.0b320670.png";